import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useEffect } from 'react';

export function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen bg-[--bg-secondary] py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link
          to="/"
          className="inline-flex items-center text-[--text-secondary] hover:text-[--text-primary] mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Link>

        <div className="bg-[--bg-primary] rounded-lg shadow-lg overflow-hidden">
          <div className="p-8">
            <h1 className="text-3xl font-bold text-[--text-primary] mb-6">
              About Scholar42 by InfiniPouch
            </h1>

            <div className="prose dark:prose-invert max-w-none">
              {/* --- START OF MODIFIED CONTENT --- */}

              <p className="text-[--text-primary]">
                Scholar42 is where academic research meets intelligent collaboration. As the flagship academic product from <strong>InfiniPouch LLC</strong>, we are building the trusted partner for the entire research journey — from initial idea to impactful publication. We believe researchers should focus on innovation, not tedious tasks.
              </p>

              <h2 className="text-[--text-primary]">Our Mission: From Tedious to Transformative</h2>
              <p className="text-[--text-primary]">
                Our mission is to free researchers from the non-creative overload that slows down discovery. We eliminate the friction in formatting, citation management, and literature screening, empowering scientists and scholars to dedicate their energy to what truly matters: asking bold questions and creating new knowledge.
              </p>

              <h2 className="text-[--text-primary]">Our Approach: From Assistant to Collaborator</h2>
              <p className="text-[--text-primary]">
                Unlike fragmented tools that only polish text, Scholar42 is an end-to-end research platform. We provide support across the full research cycle through three core pillars:
              </p>
              <ul className="text-[--text-primary]">
                <li>
                  <strong>Efficient Writing:</strong> Smart guidance strengthens your paper's structure and academic tone, while automatically adapting to any journal's standards.
                </li>
                <li>
                  <strong>Smart Literature:</strong> Our system intelligently recommends relevant literature, extracts key insights, and handles citation generation in one click.
                </li>
                <li>
                  <strong>Innovation Engine:</strong> This is our core differentiator. Our Agentic AI acts as a pathfinder, helping you explore research directions, identify high-potential topics, and validate your path early to avoid costly pivots.
                </li>
              </ul>

              <h2 className="text-[--text-primary]">Our Vision: The Intelligent Collaborator for Research</h2>
              <p className="text-[--text-primary]">
                Just as Autonomous Coding Agents empower developers, we envision Scholar42 as the indispensable intelligent collaborator for every researcher. We are building the core engine for academic workflows, a true partner that helps you turn ideas into impact.
              </p>

              {/* --- END OF MODIFIED CONTENT --- */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}